import $http from '../../shared/http';

export const roles = {
  namespaced: true,
  state: () => {
    return {
      roles: [],
      roleUsers: [],
      rolePermissions: [],
      currentRole: null,
      roleEdited: false,
      newRoleID: null,
      rolesForSelect: null,
    };
  },
  getters: {
    getErrorMessage: (state) => state.errorMessage,
    getRoles: (state) => state.roles,
    getRoleUsers: (state) => state.roleUsers,
    getRolePermissions: (state) => state.rolePermissions,
    getAuthRole(state, getters, rootState, rootGetters) {
      return rootGetters['auth/getAuthRole'];
    },
    getRolesForSelect(state) {
      return state.rolesForSelect;
    },
    getCurrentRole: (state) => state.currentRole,
    getRolePermissionsForSelect: (state) =>
      state.rolePermissions.map((role) => {
        return role.id;
      }),
  },
  mutations: {
    setErrorMessage: (state, message) => {
      state.errorMessage = message;
    },

    setRoles: (state, rolePayload) => {
      state.roles = rolePayload;
    },
    setRoleUsers: (state, users) => {
      state.roleUsers = users;
    },
    setRolePermissions: (state, users) => {
      state.rolePermissions = users;
    },
    setCurrentRole: (state, payload) => {
      state.currentRole = payload;
    },
    setRolesForSelect: (state, payload) => (state.rolesForSelect = payload),
  },
  actions: {
    async loadRoles({ commit }) {
      return await $http()
        .get('/roles', {
          params: {
            no_paginate: true,
          },
        })
        .then((response) => {
          commit('setRoles', response.data.data);
          return response;
        })
        .catch((error) => {
          //console.log(error)
          return error;
        });
    },
    async loadRole({ commit }, role_id) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/roles/${role_id}`)
          .then((response) => {
            //console.log(response)
            commit('setCurrentRole', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async loadRoleUsers({ commit }, id) {
      return await $http()
        .get('/roleUsers', {
          params: {
            role_id: id,
          },
        })
        .then((response) => {
          //console.log(response.data)
          commit('setRoleUsers', response.data.roleUsers);
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async loadRolePermissions({ commit }, id) {
      return await $http()
        .get('/rolePermissions', {
          params: {
            role_id: id,
          },
        })
        .then((response) => {
          //console.log(response.data)
          commit('setRolePermissions', response.data.data);
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async loadRolesForSelect({ commit }, { churchId, ...payload }) {
      return $http('v2')
        .get(`${churchId ? `organisations/${churchId}/roles/select` : 'roles/select'}`, {
          params: payload,
        })
        .then((response) => {
          commit('setRolesForSelect', response.data.data);
          return response;
        });
    },
    async editRole(ctx, { form, id }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .put(`/roles/${id}`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then((/* response */) => {
            return resolve(id);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async createRole(ctx, form) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post('/role', form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then((response) => {
            return resolve(response.data.data.id);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async deleteRole(ctx, { id }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .delete('/role', {
            params: {
              role_id: id,
            },
            notifiable: true,
          })
          .then((response) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
  },
};
